import { render } from "./ThankyouHundred.vue?vue&type=template&id=7004999a&scoped=true&ts=true"
import script from "./ThankyouHundred.vue?vue&type=script&lang=ts"
export * from "./ThankyouHundred.vue?vue&type=script&lang=ts"

import "./ThankyouHundred.vue?vue&type=style&index=0&id=7004999a&scoped=true&lang=css"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7004999a"]])

export default __exports__